/**
 * 当前为顶级窗口
 * @returns
 */
export function isTopWindow() {
  return window.top === window
}
/**
 * 保留两位小数
 * @param {*} num 数值
 */
export function formatToDecimal(num: any) {
  if (!num) return '0.00'
  num = Number(num)
  return num.toFixed(2)
}

export function formatCity(arr: any) {
  if (arr instanceof Array) {
    arr.map((item, index) => {
      if (item.children) {
        formatCity(item.children)
        item.label = item.text
        item.value = item.value
      } else {
        item.label = item.text
        item.value = item.value
      }
    })
  }
  return arr
}

// 根据id查询省市区
export function test(datas: any, ...arg: any): any {
  const [firstId, ...lastIds] = arg
  const matchData = datas.find((item: any) => {
    return item.value === firstId
  })
  if (lastIds.length) {
    return [matchData].concat(test(matchData.children, ...lastIds))
  } else {
    return [matchData]
  }
}

export function getExtForRemoteFileId(path: any) {
  try {
    const url = new URL(path)
    const dataParam = url.searchParams.get('data')
    if (!dataParam) return 'file'

    // 解码并解析 JSON 数据
    const decodedData = decodeURIComponent(dataParam)
    const dataObj = JSON.parse(decodedData)
    const remoteFileId = dataObj.remoteFileId

    if (!remoteFileId) return 'file'

    // 提取扩展名并判断
    const extension = remoteFileId.split('.').pop().toLowerCase()

    // 图片
    const imageExt = ['png', 'jpg', 'jpeg', 'jpe', 'jxr', 'tif', 'tiff', 'bmp', 'webp']
    // 视频
    const videoExt = ['mp4', '3gp', 'avi', 'wmv', 'mpeg', 'mpg', 'mov', 'flv', 'swf', 'qsv', 'kux', 'mpg', 'rm', 'ram']

    if (imageExt.includes(extension)) {
      return 'image'
    }

    if (videoExt.includes(extension)) {
      return 'video'
    }

    return 'file'
  } catch (error) {
    return 'file'
  }
}


/**
 * 提取字符串中第一个连续的数字序列
 * @param {string} str - 任意输入字符串
 * @returns {string|null} - 第一个数字序列（字符串形式，保留前导零），如果没有数字则返回 null
 */
export function getTdlNumber(str: String) {
  if(!str) return null
  str = str.trim();
  // 匹配第一个连续的数字序列（一个或多个数字）
  const match = str.match(/\d+/);
  return match ? +(match[0]) : null;
}
